import { t } from "i18next";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useOutletContext } from "react-router-dom";
import ErrorsBlock from "../../../components/errors/ErrorsBlock";
import { useFetch } from "../../../hooks/useFetch";
import { useAppStore } from "../../../stores/RootStore";
import { SiteById, UserCompact } from "../../../types/types";
import { Button } from "../../../ui/Button";
import { Input } from "../../../ui/Input/Input";
import { Label } from "../../../ui/Label/Label";
import { ScrollArea } from "../../../ui/ScrollArea/ScrollArea";

const AddOrganization = () => {
  const [sites, setSites] = useOutletContext<[SiteById[], Function]>();

  const [errors, setErrors] = useState([]);
  const { register, reset, handleSubmit, control } = useForm({
    defaultValues: {
      name: "",
      short_name: "",
    },
  });

  const [{ response: saveResponse, isLoading: saveIsLoading, error: saveError }, doFetchItemSave] = useFetch(
    `/users/sites`,
    true
  );

  const onSubmit = (formData: any) => {
    setErrors([]);
    doFetchItemSave({
      method: "POST",
      data: {
        data: {
          name: formData.name,
          short_name: formData.short_name,
        },
      },
    });
    reset();
  };

  const addNewOrganization = (itemSaveResponse: { data: unknown }) => {
    const newSiteData = itemSaveResponse.data as unknown as SiteById;
    setSites([...sites, newSiteData]);
  };

  useEffect(() => {
    if (!saveResponse) return;
    addNewOrganization(saveResponse);
  }, [saveResponse]);

  useEffect(() => {
    if (!saveError) return;
    setErrors(saveError.errors);
  }, [saveError]);

  return (
    <ScrollArea className="w-full">
      <div className="flex flex-col max-w-[900px] w-full justify-start mx-auto pl-4 pr-16 relative overflow-hidden my-[4rem]">
        <div className="text-xl font-semibold">{t("adding_organization")}</div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col w-full pt-8 h-full gap-3">
            <Controller
              name="name"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("title_name")}*`} />
                </div>
              )}
            />
            <Controller
              name="short_name"
              control={control}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("abbreviation")}`} />
                </div>
              )}
            />

            <Button type="submit" className="mt-8">
              {t("save")}
            </Button>
            {errors.length > 0 ? <ErrorsBlock errors={errors} /> : ""}
          </div>
        </form>
      </div>
    </ScrollArea>
  );
};

export default AddOrganization;
